import { Injectable } from '@angular/core';
import { HttpRequestService } from './http-request.service';
import { RegulationModel } from '../models/regulation-model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AIRegulationService {

  private stateUrl = 'api/v1/admin/ai-regulation';
  private regulationUpdateURL = 'api/v1/admin/translate/module-field';
  private saveDraftURL = 'api/v1/admin/regulations';

  constructor(
    private httpRequest: HttpRequestService
  ) { }

  addRegulation(regulationModel:RegulationModel): Observable<Response> {
    return this.httpRequest.post(this.stateUrl,regulationModel);
  }

  createDraftRegulation(id: String): Observable<Response> {
    return this.httpRequest.postIndexing(this.stateUrl+'/generate-draft-regulation'+ '/' + id);
  }

  getAllRegulations(body:any):  Observable<any> {
    return this.httpRequest.post(this.stateUrl+"/list",body);
  }

  deleteById(id: String): Observable<Response> {
    return this.httpRequest.delete(`${this.stateUrl}/${id}`);
  }

  deleteAllById(id: String, ids: Array<any>): Observable<Response> {
    return this.httpRequest.delete(`${this.stateUrl}?ids=${ids.join(',')}`);
  }

  findById(regulationId:any): Observable<any> {
    return this.httpRequest.get(this.stateUrl+'/'+regulationId);
  }

  updateRegulation(regulationModel:RegulationModel): Observable<Response> {
    return this.httpRequest.put(this.stateUrl+'/'+regulationModel.id,regulationModel);
  }

  saveDraftRegulation(regulationModel:RegulationModel): Observable<Response> {
    return this.httpRequest.put(this.saveDraftURL+'/'+regulationModel.actualReguId,regulationModel);
  }

  publishMultipleDraftRegulation(regulationList:Array<RegulationModel>): Observable<Response> {
    return this.httpRequest.post(this.saveDraftURL+'/add-multiple', regulationList);
  }  

  quickEditRegulation(body : any): Observable<Response> {
    return this.httpRequest.post(this.stateUrl +'/quickEdit' + '/' +body.id, body);
  }

  getLastChangeSummery(dataId : any): Observable<any> {
    return this.httpRequest.get(this.stateUrl +'/last-changes?dataId='+dataId+'&type=Regulation');
  }
}